var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vld-parent"},[_c('loading',{attrs:{"active":_vm.isLoading,"color":"#0098cc","loader":"dots"},on:{"update:active":function($event){_vm.isLoading=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }